import { useTranslation } from 'react-i18next';

export function BookmarksPage() {
  const { t } = useTranslation('members');

  return (
    <>
      <div className="mb-8">
        <h1 className="text-h1 font-semibold">{t('pages.bookmarks.title')}</h1>
        <p className="text-muted-foreground mt-1">{t('pages.bookmarks.subtitle')}</p>
      </div>
      <div className="rounded-lg border border-dashed p-12 text-center">
        <p className="text-muted-foreground">{t('pages.bookmarks.empty')}</p>
      </div>
    </>
  );
}
